import React, { useState } from 'react';

interface Tab {
    id: string;
    label: string;
};

interface TabSwitcherProps {
    tabs: Tab[];
    defaultId?: string,
    onTabChange: (id: string) => void;
};

export function TabSwitcher({ tabs, onTabChange, defaultId }: TabSwitcherProps) {
    const [activeTab, setActiveTab] = useState<string>(defaultId || tabs[0]?.id);

    const handleTabClick = (id: string) => {
        setActiveTab(id);
        onTabChange(id);
    };

    return (
        <div className="flex w-full max-w-xs space-x-2 rounded-full ">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => handleTabClick(tab.id)}
                    className={`px-4 rounded-full py-1 text-sm font-semibold leading-5 transition-colors duration-300 ease-in-out focus:outline-none
            ${
                        activeTab === tab.id
                            ? ' bg-gray-100 text-gray-700' // Active tab styles
                            : ' text-gray-500 hover:bg-white/60' // Inactive tab styles
                    }
          `}
                >
                    {tab.label}
                </button>
            ))}
        </div>
    );
};

